export default "__VITE_ASSET__C1fPD8M1__"